import React from 'react';
import BusinessDetailSection from '../../../sections/AdminDashboard/UserManagement/BusinessDetail';

const BusinessDetail = () => {
  return <BusinessDetailSection />;
};

export default BusinessDetail;

